<template>
  <PopupContent
    id="mapPopup"
    :graph-id="graphId"
    :disable-chart="isMobile"
    :popup-details="popupDetails"
    :title-prop="title"
  />
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import PopupContent from '@/components/public/Popup/PopupContent.vue'
import { MapPopupDetails } from '@/types'

const components = {
  PopupContent,
}

const props = {
  popupDetails: {
    type: Object as PropType<MapPopupDetails>,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  graphId: {
    type: String,
    default: 'popupGraph',
  },
}

@Component({ components })
export default class MapPopup extends Vue.extend({ props }) {
  get isMobile() {
    return this.$typedStore.public.display.isMobile
  }
}
</script>

<style>
.map-container .card {
  position: absolute;
  bottom: 0;
  right: 0;
  min-width: 300px;
  opacity: 0.8;
  z-index: 500;
}
</style>
